import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {makeStyles} from "@material-ui/styles";
import {useTranslation} from "react-i18next";
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import useTheme from "@material-ui/styles/useTheme";

const useStyles = makeStyles((theme) => ({
    autocompleteWrap: {
        margin: theme.spacing(4, 0)
    }
}))

const RSIGESTORZYsearchGestor = ({dataSet, onSelect, onInputChange}) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const theme = useTheme();

    const options = dataSet.map((option) => {
        const firstLetter = option.title[0].toUpperCase();
        return {
            firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
            ...option,
        };
    });

    const handleChange = (event, value, reason) => {
        // console.log('handleChange: ', event, value, reason);

        if (reason === 'clear') {
            value = value ? {...value, id : 'startOfList'} : {id: 'startOfList'}
        };
        value && onSelect({itemId: value.id, firstLetter: value.firstLetter})
    }
    
    const handleInputChange =(newInputValue)=>{
        // console.log('handleInputChange in autocomplete: ', newInputValue)
        onInputChange(newInputValue)
    }

    return (
        <Autocomplete
            id="grouped-RSIGESTORZYsearchGestor"
            freeSolo
            open={false}
            options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
            groupBy={(option) => option.firstLetter}
            getOptionLabel={(option) => option.title}
            getOptionSelected={(option) => option.title}
            className={classes.autocompleteWrap}
            fullWidth
            onChange={handleChange}
            onInputChange={(event, newInputValue) => {
                handleInputChange(newInputValue);
            }}
            renderInput={
                (params) =>
                    <TextField
                        color="primary" {...params}
                        label={t('common.RSIGESTORZYsearchGestor')}
                        variant="outlined"
                        size={'small'}
                    />
            }
            renderOption={(option, {inputValue}) => {
                const matches = match(option.title, inputValue);
                const parts = parse(option.title, matches);

                return (
                    <div>
                        {parts.map((part, index) => (
                            <span key={index}
                                  style={{
                                      // fontWeight: part.highlight ? 700 : 400,
                                      backgroundColor: part.highlight ? theme.palette.primary.main : 'inherit',
                                      color: part.highlight ? theme.palette.primary.contrastText : 'inherit'
                                  }}>
                                {part.text}
                            </span>
                        ))}
                    </div>
                );
            }}
        />
    );
}

export default RSIGESTORZYsearchGestor;
